<template>
    <div>
        <div class="main-cnt ex-has-btn-btm">
            <div class="error-message" v-if="errorMessage">
                <div class="d-flex">
                    <i class="icon-warning mr-2"></i>
                    <div class="errror-txt">
                        <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                        <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                    </div>
                </div>
            </div>
            <component
                v-bind:is="component"
                v-if="voucher.voucher_type_id"
                :voucher="voucher"
                :history="history"
                @select-update-files="selectUpdateFiles"
            ></component>

            <div class="text-right" v-show="!utils.isReadOnly()">
                <button
                    class="btn btn-delete-detail"
                    :class="{ 'is-disabled': !canDelete(voucher.voucher_type_id, voucher) }"
                    :disabled="!canDelete(voucher.voucher_type_id, voucher)"
                    data-toggle="modal"
                    data-target="#confirmDelete"
                    v-show="!isCheckined"
                >
                    <i class="icon-trash-g"></i>
                </button>
            </div>
        </div>

        <!-- The Modal Confirm to delete -->
        <div class="modal fade modal-upload" id="confirmDelete">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal body -->
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>

                        <div class="center-modal">
                            <div class="center-ttl font300 d-flex justify-content-center">
                                <i class="icon-trash-g mr-2"></i>
                                <span class="font500 text-pink">{{$t('voucher.delete.confirm')}}</span>
                            </div>

                            <div class="row mt-4 no-gutters">
                                <div class="col-6 pr-2">
                                    <button
                                        class="btn btn-pink-53 w-100"
                                        data-dismiss="modal"
                                        data-toggle="modal"
                                        @click="deleteVoucher(voucherId)"
                                    >{{$t('button.ok')}}</button>
                                </div>

                                <div class="col-6 pl-2">
                                    <button class="btn btn-gray-53 w-100" data-dismiss="modal">{{$t('button.cancel')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <SpCameraPreProcessingVoucher
            v-if="showPreprocessingUpdate"
            :files.sync="updateFileList"
            :voucherType="voucher.voucher_type_id"
            :isUpdate="true"
            :voucher="voucher"
            @update-files="updateFiles"
            @finish="finishUpdateFile"
            @close="closeUpdateFile"
            @enableButton="$emit('enableButton', $event)"
            @update:actionHandler="$emit('update:actionHandler', $event)"
            @update:backHandler="$emit('update:backHandler', $event)"
        ></SpCameraPreProcessingVoucher>
    </div>
</template>

<script>
import VoucherType1 from "@/views/components/sp/Voucher/Details/Temp_1.vue";
import SpCameraPreProcessingVoucher from "@/views/components/sp/Voucher/CameraPreProcessing";
import VoucherManagementService from "@/services/module/voucher.service";
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";
import Utils from "@/helpers/utils";
import { Constants } from "@/helpers/constants";
export default {
    components: {
        VoucherType1,
        SpCameraPreProcessingVoucher,
    },
    name: "SpDetailVoucher",
    data () {
        return {
            voucher: {},
            voucherId: "",
            errorMessage: "",
            screenType: "",
            isCheckined: false,
            utils: Utils,
            showPreprocessingUpdate: false,
            updateFileList: [],
        };
    },
    computed: {
        component: {
            get: function () {
                if (this.voucher.voucher_type_id) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );
                        return () => import(`./Details/Temp_` + templateId + `.vue`);
                }
            },
        },
    },
    created () {
        this.$emit("enableButton", this.$t("button.edit"));
        this.$emit("update:actionHandler", () => {
            this.editVoucher();
        });
        let voucherId = this.$route.query.voucherId;
        this.screenType = this.$route.query.screenType;
        this.getVoucherDetails(voucherId);
        this.voucherId = voucherId;
    },
    methods: {
        isContractVoucher (voucherTypeId) {
            if (Utils.isEmptyStr(voucherTypeId)) {
                return false;
            }
            return voucherTypeId == Constants.VoucherType.contract_travel.id || voucherTypeId == Constants.VoucherType.contract_underwriting.id ||
             voucherTypeId == Constants.VoucherType.before_conditions.id || voucherTypeId == Constants.VoucherType.before_schedule.id || voucherTypeId == Constants.VoucherType.before_items.id || voucherTypeId == Constants.VoucherType.before_pamphlet.id || voucherTypeId == Constants.VoucherType.before_bulk.id ||
             voucherTypeId == Constants.VoucherType.after_conditions.id || voucherTypeId == Constants.VoucherType.after_schedule.id || voucherTypeId == Constants.VoucherType.after_items.id || voucherTypeId == Constants.VoucherType.after_bulk.id ||
             voucherTypeId == Constants.VoucherType.confirm_conditions.id || voucherTypeId == Constants.VoucherType.confirm_schedule.id || voucherTypeId == Constants.VoucherType.confirm_items.id || voucherTypeId == Constants.VoucherType.confirm_bulk.id;
        },
        canEdit (voucherTypeId, voucher) {
            if (Utils.isEmptyStr(voucherTypeId)) {
                return false;
            }
            return !(
                voucher.doc_id != null
                    &&
                voucher.doc_id !== ""
                    &&
                voucher.box_file_id == null
            );
        },
        canDelete (voucherTypeId, voucher) {
            if (Utils.isEmptyStr(voucherTypeId)) {
                return false;
            }
            return voucher.box_file_id != null && voucher.box_file_id !== "";
        },
        getVoucherDetails (voucherId) {
            return VoucherManagementService.getVoucherDetails(voucherId).then(
                response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                        return false;
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.setErrorMessage(
                                this.$root.$t("error.error_code_" + errorCode)
                            );
                        }
                        return false;
                    } else {
                        if (!Utils.isEmptyObj(response.data)) {
                            this.voucher = response.data;
                            this.history = response.data.history;
                            if (!Utils.isEmptyObj(this.history)) {
                                this.isCheckined = true;
                            } else {
                                this.isCheckined = false;
                            }
                            if (!this.isContractVoucher(this.voucher.voucher_type_id)) {
                                this.$emit("enableButton", this.$t("button.edit"));
                                this.$emit("update:actionHandler", () => {
                                    this.editVoucher();
                                });
                            }
                            if (!this.canEdit(this.voucher.voucher_type_id, this.voucher)) {
                                // ボタンの表示のために enableButton を発行する
                                this.$emit("enableButton", this.$t("button.edit"));
                                // 表示したボタンを無効化するために disableButton を発行する
                                this.$emit("disableButton");
                            }
                            this.setErrorMessage("");
                            if ((this.screenType == Constants.LocalIncomeScreenType && this.voucher.type == Constants.VoucherInOutType.Out.id) ||
                            (this.voucher.voucher_type_id == Constants.VoucherType.local_expense_voucher_receipt.id && (this.voucher.service == Constants.VoucherService.Optional.id ||
                            this.voucher.service == Constants.VoucherService.Agreement.id || this.voucher.service == Constants.VoucherService.Gifts.id ) && this.voucher.type == Constants.VoucherInOutType.Out.id)) {
                                this.voucher.total_amount = this.voucher.total_amount * -1;
                                this.voucher.income = this.voucher.income * -1;
                            }
                            return true;
                        } else {
                            this.voucher = [];
                            const message =
                                this.$root.$t("general.no_data");
                            this.$toasted.success(message, {});
                            return false;
                        }
                    }
                }).catch (error => {
                    let message =
                        this.$root.$t("error.error_unknown");
                    const errorCode = Utils.getErrorCode(error);

                    if (errorCode) {
                        message = this.$root.$t(
                            "error.error_code_" + errorCode
                        );
                    }
                    this.setErrorMessage(message);
                    this.$toasted.error(message, {
                        icon: "fa-exclamation-triangle",
                    });

                    return false;
                });
            },
        deleteVoucher (voucherId) {
            VoucherManagementService.deleteVoucher(voucherId).then(response => {
                if (response.status != 200) {
                    let msg = this.$root.$t("fail.delete_fail");

                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        msg = this.$t('error.error_code_' + errorCode);
                        this.setErrorMessage(msg);
                    }

                    this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                } else {
                    // this.$router.push({ path: "/voucher/list" });
                    this.setErrorMessage("");
                    let msg = this.$root.$t("success.delete_success");

                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        msg = this.$t('error.error_code_' + errorCode);
                        this.setErrorMessage(msg);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    } else {
                        this.$toasted.success(msg, {icon: 'fa-check'});
                    }
                    this.$router.go(-1);
                }

                // this.$router.replace({
                //  path: "/voucher/list",
                //  query: { screenType: this.screenType }
                // });
            }).catch(error => {
                this.setErrorMessage(this.$root.$t("error.error_unknown"));
                let msg = this.$root.$t("fail.delete_fail");
                this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
            });
        },
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },
        editVoucher () {
            this.$router.push({
                path: "/voucher/edit",
                query: {
                    voucherId: this.voucherId,
                    screenType: this.screenType,
                },
            });
        },
        selectUpdateFiles () {
            this.updateFileList = [];
            this.showPreprocessingUpdate = true;
        },
        async updateFiles (formD) {
            try {
                // S3へファイルをアップロード
                const uploadResponse = await VoucherManagementService.upload(
                    formD
                );

                // アップロード失敗時の処理
                if (!uploadResponse || uploadResponse.status !== 200) {
                    if (uploadResponse && uploadResponse.status === 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                        return;
                    }

                    const errorCode = uploadResponse
                        ? Utils.getErrorCode(uploadResponse)
                        : null;

                    const message = errorCode
                        ? this.$root.$t("error.error_code_" + errorCode)
                        : this.$root.$t("error.error_unknown");

                    this.setErrorMessage(message);
                    this.$toasted.error(message, {});
                    return;
                }

                // S3のファイルパスを取得
                const filePath = uploadResponse.data
                    ? uploadResponse.data.path
                    : null;

                if (!filePath) {
                    const message = this.$root.$t("error.error_unknown");

                    this.setErrorMessage(message);
                    this.$toasted.error(message, {});
                    return;
                }

                // ファイル差し替えAPIを実行
                const path = require("path");

                const response = await VoucherManagementService.updateFile(
                    this.voucher.id,
                    {
                        filePath: filePath,
                        extend: path.extname(filePath),
                        csrfToken: Utils.generateRandomString()
                    }
                );

                if (!response || response.status !== 200) {
                    if (response && response.status === 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                        return;
                    }

                    const errorCode = response
                        ? Utils.getErrorCode(response)
                        : null;

                    const message = errorCode
                        ? this.$root.$t(
                            "error.error_code_" + errorCode
                        )
                        : this.$root.$t("error.error_unknown");

                    this.setErrorMessage(message);
                    this.$toasted.error(message, {});
                    return;
                }

                const detailsLoaded =
                    await this.getVoucherDetails(this.voucherId);

                if (!detailsLoaded) {
                    return;
                }

                this.finishUpdateFile();

                const message = this.$root.$t("success.update_success");
                this.$toasted.success(message, { icon: "fa-check" });
            } catch (error) {
                const message =
                    this.$root.$t("fail.update_fail");

                this.setErrorMessage(message);
                this.$toasted.error(message, {
                    icon: "fa-exclamation-triangle",
                });
            }
        },
        finishUpdateFile () {
            this.showPreprocessingUpdate = false;
            this.updateFileList = [];

            this.$emit(
                "enableButton",
                this.$t("button.edit")
            );

            if (!this.canEdit(this.voucher.voucher_type_id, this.voucher)) {
                this.$emit("disableButton");
            }

            this.$emit("update:actionHandler", () => {
                this.editVoucher();
            });
            this.$emit("update:backHandler", () => {
                this.$router.go(-1);
            });
        },
        closeUpdateFile () {
            this.showPreprocessingUpdate = false;
            this.updateFileList = [];

            this.$emit('enableButton', this.$t('button.edit'));

            if (!this.canEdit(this.voucher.voucher_type_id, this.voucher)) {
                this.$emit("disableButton");
            }

            this.$emit('update:actionHandler', () => {
                this.editVoucher();
            })
            this.$emit("update:backHandler", () => {
                this.$router.go(-1);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/Detail.vue